import { GetInstrumentsResponseItem } from '@Common/types/bo/instruments';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const statusChoices = makeChoicesCommon<GetInstrumentsResponseItem['status']>()({
  active: 'resources.bo_common.instruments.status.active',
  inactive: 'resources.bo_common.instruments.status.inactive',
});
